<template>
	<div>
		<v-container>
			<v-row>
				<v-col lg="12" class="pb-1">
					<s-crud
						:config="config"
						:filter="filter"
						title="Programación de Acopio"
						add
						:edit="!disabled"
						searchInput
						ref="gridProgrammingStorage"
						@save="save($event)"
						@addEvent="CleanAll()"
						@EditEvent="EditEvent()"
						@rowSelected="rowSelected($event)"
						no-full
						height="auto"
						:single-row="false"
						:groupBy="'TptEnrollment'"
					>
						<template v-slot:options> 
							<v-tooltip bottom="" v-if="programmingStorageSelected.length == 1 && selectedHeader.PseID > 0 && $fun.hasSpecialPermission('AddVehicle')">
								<template v-slot:activator="{ on }">
									<v-btn
									v-on="on"
									text
									black 
									@click="openDialogAssignVehicle()"
									small
									>
									<i class="mdi mdi-truck"></i>
									</v-btn>
								</template>
								<span>Asignar Vehículo</span>
							</v-tooltip>
							<v-tooltip bottom="" v-if="selectedHeader.PseID > 0">
								<template v-slot:activator="{ on }">
									<v-btn
									v-on="on"
									text
									black 
									@click="openDialogGuide()"
									small
									>
									<i class="mdi mdi-note-text"></i>
									</v-btn>
								</template>
								<span>Guía Remisión</span>
							</v-tooltip>
							<v-tooltip bottom="" v-if="programmingStorageSelected.length == 1 && selectedHeader.PseID > 0">
								<template v-slot:activator="{ on }">
									<v-btn
									v-on="on"
									text
									black 
									@click="openDialogAuditHistory()"
									small
									>
									<i class="mdi mdi-history"></i>
									</v-btn>
								</template>
								<span>Historial de Cambios / Auditoría</span>
							</v-tooltip>
						</template>
						
						<!-- Filtros -->
						<template v-slot:filter>
							<v-container>
								<v-row justify="center" class="s-col-form">
									<v-col lg="2" v-if="filter.PseState == 3 || filter.PseState == 1">
										<v-btn
											style="margin-top: 15px; margin-left: -10px;"
											small
											block
											color="primary"
											@click="duplicate()"
										>
											Duplicar registro
										</v-btn>
									</v-col>
									<v-col lg="2" v-if="filter.PseState == 3 || filter.PseState == 1">
										<v-btn
											style="margin-top: 15px; margin-left: -10px;"
											small
											block
											color="warning"
											@click="remove()"
										>
											Eliminar
										</v-btn>
									</v-col>
									<v-col lg="2"
										><s-date
											label="Fecha Inicio"
											v-model="filter.cDateInitial"
										></s-date>
									</v-col>
									<v-col lg="2"
										><s-date
											label="Fecha Fin"
											v-model="filter.cDateFin"
										></s-date>
									</v-col>
									<v-col lg="3">
										<s-select-definition
											v-model="filter.PseState"
											:def="1215"
											label="Estado"
										/>
									</v-col>
								</v-row>
							</v-container>
						</template>

						<template scope="props">
							<v-card>
								<v-row>
									<div class="col-md-12 col-sm-12">
										<v-col cols="12" md="12">
											<v-row>
												<v-col lg="4" md="4" cols="12">
													<s-select-definition
														:def="1212"
														label="Tipo de Transporte"
														v-model="
															props.item
																.TypeTransport">
													</s-select-definition>
												</v-col>

												 <v-col lg="4" md="4" cols="12">
													<s-select-definition
													v-model="props.item.TypeService"
													:def="1171"
													label="Tipo Servicio"
													/>
												</v-col>

												 <v-col
													md="4"
													cols="12"
													:lg="props.item.TypeProcessingPlant == 2 ? 2 : 4">
													<s-select-definition
													v-model="props.item.TypeProcessingPlant"
													:def="1171"
													label="Planta Procesadora"
													/>
												</v-col>

												<v-col
													cols="12"
													md="4"
													lg="2"
													v-if="props.item.TypeProcessingPlant == 2"
												>
													<s-select-definition
													label="Empacadora"
													:def="1226"
													v-model="props.item.TypeBaler"
													clearable
													/>
												</v-col>

												<v-col
													cols="12"
													md="4"
													style="display: flex;"
												>
													<s-select-producer
														style="width: inherit;"
														clearable
														:text="
															props.item.PrdName
														"
														return-object
														v-model="ObjProducer"
														label="Productor"
														@input="
															inputProducer(
																$event
															)
														"
													/>
												</v-col>

												<v-col lg="2" md="2" cols="12">
													<s-select-definition
														:def="1175"
														label="Destino"
														:value="2"
														v-model="TypeDestiny"
													>
													</s-select-definition>
													<!-- v-model="props.item.TypeDestiny" -->
												</v-col>

												<v-col lg="2" cols="12" md="2">
													<s-select-definition
														label="Tipo Carga"
														:def="1231"
														v-model="
															props.item
																.TypeCharge
														"
													/>
												</v-col>

											<v-col lg="4" cols="6" md="4">
												<s-date label="Fecha de Recojo" v-model="props.item
													.PseAproximateArrivaleDate
													"></s-date></v-col>
											<v-col lg="2" cols="6" md="2">
												<s-select-transport clearable label="Vehiculo" full return-object
													v-model="ObjTransport"
													:text="props.item.TptEnrollment"
													@input="changeTraspot($event)"
													disabled>
												</s-select-transport></v-col>

												<v-col lg="2" cols="12" md="2">
													<s-text
														label="Tipo de Vehiculo"
														disabled
														v-model="
															TypeVehicleName
														"
													></s-text>
												</v-col>
												<v-col lg="4" cols="12" md="4">
													<s-text
														label="Chofer"
														disabled
														v-model="NameDrive"
													></s-text>
												</v-col>
												<v-col lg="2"   cols="6">
													<s-select-definition :def="1396" label="Tipo de Entrada de Mercancía" v-model="props.item.TypeEntryMerchandise">
													</s-select-definition>
												</v-col>
												<v-col lg="2"   cols="6">
													<s-select-definition :def="1612" label="Modalidad de Traslado" v-model="props.item.TypeMode">
													</s-select-definition>
												</v-col>
												
											</v-row>

											<v-row>
												<v-col lg="12" cols="12">
													<div class="d-flex align-center justify-space-between">
														<s-toolbar
															add
															@add="newItem()"
															:color="editingDetailLine ? 'primary' : '#BAB6B5'"
															dark
															:label="editingDetailLine ? 'Actualizar Item (Línea #' + editingDetailLine + ')' : 'Nuevo Item'"
														/>
														<v-btn
															v-if="editingDetailLine"
															x-small
															color="warning"
															class="ml-2 px-2 text-none font-weight-bold"
															@click="cancelEditDetail()"
														>
															<v-icon x-small left>mdi-close-circle</v-icon>
															Cancelar Edición
														</v-btn>
													</div>
													<v-divider
														horizontal
													></v-divider>
													<v-card
														rounded=""
														class="elevation-0"
													>
														<v-col
															style="padding-bottom:24px;"
														>
															<v-row
																justify="center"
															>
																<v-col
																	cols="12"
																	md="12"
																	lg="12"
																	v-if="PrdID > 0"
																>
																	<s-select-lot
																		:PrdID="PrdID"
																		FltName="FltNameOne"
																		:indicadorLot="0"
																		clearable
																		full
																		label="Lote"
																		return-object
																		v-model="objLot"
																		@input="inputLot($event)"
																/></v-col>
																<v-col
																	cols="12"
																	md="3"
																	lg="3"
																>
																	<s-select-definition
																		:def="
																			1176
																		"
																		label="Localidad"
																		returnObject
																		v-model="
																			objTypeLocation
																		"
																	>
																	</s-select-definition>
																</v-col>

																<!-- </v-row>

																		<v-row> -->
																<v-col
																	cols="12"
																	md="3"
																	lg="3"
																>
																	<s-select-definition
																		clearable
																		:def="1172"
																		label="Tipo Cultivo"
																		v-model="objTypeCrop"
																		return-object
																	/>
																	
																</v-col>

																<!-- <v-col
																	cols="12"
																	md="2"
																	lg="2"
																>
																	<s-select-definition
																		:def="
																			1173
																		"
																		label="Cultivo"
																		returnObject
																		v-model="
																			objTypeCultive
																		"
																	/>
																</v-col> -->

																<v-col
																	cols="12"
																	md="2"
																	lg="2"
																>
																	<s-text
																		label="Variedad"
																		:value="varietyText"
																		readonly
																	/>
																</v-col>
																<v-col
																	cols="12"
																	md="2"
																	lg="2"
																	><s-text
																		number
																		label="Cantidad Estimada"
																		v-model="
																			PsdQuantity
																		"
																		:min="0"
																	></s-text
																></v-col>
																<v-col
																	cols="12"
																	md="2"
																	lg="2"
																	><s-text
																		number
																		label="Cantidad Real"
																		v-model="
																			PsdQuantityReal
																		"
																		:min="0"
																	></s-text
																></v-col>
															</v-row>
														</v-col>
													</v-card>
												</v-col>

												<v-col lg="12" cols="12">
													<v-card>
														<v-col
															style="padding:0px"
														>
															<v-data-table
																item-key="Line"
																dense
																:items="
																	itemsDetails"
																:headers="
																	headersDetail"
																:items-per-page="
																	-1"
																hide-default-footer>
																<!-- eslint-disable-next-line vue/valid-v-slot -->
																<template v-slot:item.Actions="{item}">
																	<div class="d-flex align-center justify-center">
																		<v-btn
																			@click="editDetailItem(item)"
																			x-small
																			color="primary"
																			elevation="0"
																			class="mr-1"
																			title="Editar item"
																		>
																			<v-icon style="font-size: 14px !important">mdi-pencil</v-icon>
																		</v-btn>
																		<v-btn
																			@click="removeItem(item)"
																			x-small
																			color="error"
																			elevation="0"
																			title="Eliminar item"
																		>
																			<v-icon style="font-size: 14px !important">fas fa-times</v-icon>
																		</v-btn>
																	</div>
																</template>

																<!-- Edición directa de Cantidad Estimada -->
																<template v-slot:item.PsdQuantity="props">
																	<s-text
																		number
																		v-model.number="props.item.PsdQuantity"
																		:min="0"
																		hide-details
																		dense
																	/>
																</template>

																<!-- Edición directa de Cantidad Real -->
																<template v-slot:item.PsdQuantityReal="props">
																	<s-text
																		number
																		v-model.number="props.item.PsdQuantityReal"
																		:min="0"
																		hide-details
																		dense
																	/>
																</template>
															</v-data-table>
														</v-col>
													</v-card>
												</v-col>
											</v-row>
										</v-col>
									</div>
								</v-row>
							</v-card>
						</template>
					</s-crud>
				</v-col>
			</v-row>
			<v-dialog
				v-if="dialogGuideSelected"
				v-model="dialogGuideSelected" > 
					<lgs-referral-guide-edit
						:typeGuide="typeGuide"
						@closeDialogReferral="closeDialogReferral()"
						:referralGuideSelected="referralGuide"
					></lgs-referral-guide-edit>
			</v-dialog>


			<v-dialog v-model="dialogAssignVehicle" max-width="520px" transition="dialog-bottom-transition" persistent>
				<v-card class="elevation-4 rounded-xl overflow-hidden border-subtle" outlined elevation="0">
					<!-- Header Neutro Plano (Sin gradientes ni rellenos de color) -->
					<div class="px-5 py-4 bg-white d-flex align-center justify-space-between border-subtle-bottom">
						<div class="d-flex align-center">
							<v-avatar color="grey lighten-4" size="36" class="mr-3">
								<v-icon color="grey darken-3" small>mdi-truck-delivery</v-icon>
							</v-avatar>
							<div>
								<h3 class="grey--text text--darken-4 text-h6 font-weight-black mb-0 lh-1">Asignar Vehículo</h3>
								<span class="grey--text text--darken-2 text-caption" v-if="selectedHeader && selectedHeader.PseID">
									ID: #{{ selectedHeader.PseID }} | Productor: {{ selectedHeader.PrdName }}
								</span>
							</div>
						</div>
						<v-btn icon small @click="dialogAssignVehicle = false">
							<v-icon small color="grey darken-2">mdi-close</v-icon>
						</v-btn>
					</div>
					<v-divider></v-divider>

					<v-card-text class="pa-4 bg-light">
						<!-- Selector de Placa -->
						<v-card class="pa-4 rounded-xl border-subtle bg-white mb-3" outlined elevation="0">
							<div class="d-flex align-center mb-2">
								<v-icon small color="grey darken-3" class="mr-2">mdi-magnify</v-icon>
								<span class="subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">Buscar Vehículo / Placa</span>
							</div>
							<s-select-transport
								clearable
								label="Placa del Vehículo"
								placeholder="Seleccione placa..."
								full
								return-object
								v-model="ObjTransportAssign"
							/>
						</v-card>

						<!-- Banner de Vehículo Seleccionado -->
						<v-card class="pa-3 rounded-xl border-subtle bg-white mb-3" outlined elevation="0" v-if="ObjTransportAssign && ObjTransportAssign.VehPlate">
							<div class="d-flex align-center justify-space-between mb-2">
								<div class="d-flex align-center">
									<v-chip small color="primary" dark class="font-weight-bold mr-2">
										<v-icon left x-small>mdi-truck</v-icon>
										{{ ObjTransportAssign.VehPlate }}
									</v-chip>
								</div>
								<v-btn icon small color="error" @click="clearAssignVehicle()" title="Quitar vehículo">
									<v-icon small>mdi-delete-outline</v-icon>
								</v-btn>
							</div>
							<v-divider class="my-2"></v-divider>
							<div class="d-flex align-center justify-space-between mb-2 flex-wrap" style="gap: 6px;">
								<div class="d-flex align-center">
									<v-icon color="grey darken-3" small class="mr-1.5">mdi-account-tie</v-icon>
									<span class="caption font-weight-bold grey--text text--darken-4">
										Chofer: {{ driverAssignName || ObjTransportAssign.Conductor || ObjTransportAssign.Driver || 'Sin chofer' }}
									</span>
								</div>
								<span class="caption grey--text text--darken-2" v-if="ObjTransportAssign.LicenseDriver || ObjTransportAssign.NumDocDriver">
									Doc: {{ ObjTransportAssign.LicenseDriver || ObjTransportAssign.NumDocDriver }}
								</span>
							</div>
							<!-- Transportista -->
							<div class="d-flex align-center mb-2" v-if="carrierAssignName || (ObjTransportAssign && ObjTransportAssign.SpcCompanyName)">
								<v-icon color="grey darken-3" small class="mr-1.5">mdi-domain</v-icon>
								<span class="caption font-weight-bold grey--text text--darken-4">
									Transportista: {{ carrierAssignName || (ObjTransportAssign && ObjTransportAssign.SpcCompanyName) }}
								</span>
							</div>
							<!-- Capacidad Mínima y Máxima -->
							<div class="d-flex align-center justify-space-between pt-2 bg-light px-3 py-1.5 rounded-lg border-subtle">
								<span class="caption font-weight-medium grey--text text--darken-3">
									<v-icon x-small color="grey darken-3" class="mr-1">mdi-tray-arrow-down</v-icon>
									Capacidad Mín: <b>{{ ObjTransportAssign.CfvCapacityMin || 0 }}</b>
								</span>
								<span class="caption font-weight-medium grey--text text--darken-3">
									<v-icon x-small color="grey darken-3" class="mr-1">mdi-tray-arrow-up</v-icon>
									Capacidad Máx: <b>{{ ObjTransportAssign.CfvCapacity || 0 }}</b>
								</span>
							</div>
						</v-card>

						<!-- Estado Vacío -->
						<v-card class="pa-3 text-center rounded-xl border-dashed bg-white mb-3" outlined elevation="0" v-else>
							<div class="d-flex align-center justify-center py-2">
								<v-icon small color="grey darken-1" class="mr-2">mdi-information-outline</v-icon>
								<span class="caption grey--text text--darken-2 font-weight-medium">Seleccione una placa arriba para cargar los datos del transporte</span>
							</div>
						</v-card>

						<!-- Campos Adicionales de la Asignación -->
						<v-card class="pa-4 rounded-xl border-subtle bg-white" outlined elevation="0">
							<div class="d-flex align-center mb-3">
								<v-icon small color="grey darken-3" class="mr-2">mdi-clipboard-edit-outline</v-icon>
								<span class="subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">Detalles de Carga y Acopio</span>
							</div>
							<v-row dense class="s-col-form">
								<v-col cols="12" md="6" lg="4">
									<s-select-definition
										label="Tipo Carga"
										:def="1231"
										v-model="TypeChargeAssign"
										@input="changeTypeChargeAssign($event)"
									/>
								</v-col>
								<v-col cols="12" md="6" lg="4">
									<s-text
										number
										label="Cantidad Negociada"
										v-model.number="PseQuantityNegotiated"
										:min="0"
									/>
								</v-col>
								<v-col cols="12" md="6" lg="4">
									<s-text
										number
										label="Cantidad Real"
										v-model.number="PseQuantityJabas"
										:min="0"
									/>
								</v-col>
								<v-col cols="12" md="6" lg="4">
									<s-text
										number
										label="Cant. Estibas (Acopio)"
										v-model.number="PseStowageQuantity"
										:min="0"
									/>
								</v-col>
								<v-col cols="12" md="6" lg="4">
									<s-text
										decimal
										label="Precio Cant. Estibas"
										v-model="PsePriceStowageQuantity"
									/>
								</v-col>
								<v-col cols="12" md="6" lg="4">
									<s-text
										decimal
										label="Precio"
										v-model="PsePrice"
									/>
								</v-col>
								<v-col cols="12" md="6" lg="4">
									<s-text
										decimal
										label="Falso Flete"
										v-model="PseFalseFreight"
									/>
								</v-col>
								<v-col cols="12">
									<s-textarea
										label="Descripción / Obs."
										v-model="PseDescription"
										:rows="2"
										auto-grow
									/>
								</v-col>
							</v-row>
						</v-card>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-actions class="px-5 py-3 bg-white d-flex justify-space-between">
						<v-btn
							small
							text
							color="grey darken-2"
							class="text-none font-weight-bold"
							@click="dialogAssignVehicle = false"
						>
							Cancelar
						</v-btn>
						<v-btn
							small
							color="primary"
							elevation="0"
							class="px-4 text-none font-weight-bold rounded-lg"
							@click="saveAssignVehicle()"
						>
							<v-icon left small>mdi-check-circle-outline</v-icon>
							Confirmar Asignación
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!-- Modal Historial de Auditoría (Componente Modulariado UX/UI) -->
			<programming-storage-audit-modal
				v-model="dialogAuditHistory"
				:pseId="selectedHeader ? selectedHeader.PseID : 0"
				:itemHeader="selectedHeader"
			/>
		</v-container>
	</div>
</template>

<script>
	//Service
	import _sProgrammingStorageService from "@/services/Technicalassistance/ProgrammingStorageService";
	import _sReceptionSurveillance from "@/services/Technicalassistance/ReceptionSurveillanceService";
	import _sParameter from "@/services/General/ParameterService.js";
	import _sHarvest from "@/services/Technicalassistance/HarvestSchedule";
	import _sVehicle from "@/services/Management/VehicleService.js";
	import LgsReferralGuideEdit from '@/views/Logistics/ReferralGuide/LgsReferralGuideEdit.vue';

	//Componentes
	import SSelectTransport from "@/components/HarvestSchedule/SSelectTransport";
	import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety";
	import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer.vue";
	import SSelectLot from "@/components/HarvestSchedule/SSelectLot.vue";
	import ProgrammingStorageAuditModal from "./ProgrammingStorageAuditModal.vue";

export default {
	components: {
		SSelectTransport,
		SSelectVariety,
		SSelectProducer,
		SSelectLot,
		LgsReferralGuideEdit,
		ProgrammingStorageAuditModal,
	},

	data: () => ({
		ShowVehicleApprovals: 0,
		dialogGuideSelected: false,
		referralGuide: {},
		typeGuide: 4,
		disabled: true,
		headersDetail: [
			{ text: "Acccion", value: "Actions", width: 50 },
			{ text: "Localidad", value: "TypeLocationName", width: 200 },
			/* { text: "Cultivo", value: "TypeCultiveName", width: 100 }, */
			{ text: "Tipo de Cultivo", value: "TypeCropName", width: 100 },
			{ text: "Variedad", value: "VrtName", width: 100 },
			{ text: "Cantidad Estimada", value: "PsdQuantity", width: 100 },
			{ text: "Cantidad Real", value: "PsdQuantityReal", width: 100 }
		],
		filter: { cDateInitial: null, cDateFin: null, PseState: 1 },
		config: {
			model: {
				PseID: "ID",
				PseAproximateArrivaleDate: "date"
			},
			service: _sProgrammingStorageService,
			headers: [
				{ text: "ID", value: "PseID", width: 10 },
				{
					text: "Tipo Transport",
					value: "TypeTransportName",
					width: 10
				},
				{ text: "Productor", value: "PrdName", width: 10 },
				{ text: "Tipo servicio", value: "TypeServiceName", width: 50 },
				{ text: "Planta Procesadora", value: "TypeProcessingPlantName", width: 50 },
				{ text: "Empacadora", value: "TypeBalerName", width: 50 },
				{
					text: "Fecha de Recojo",
					value: "PseAproximateArrivaleDate",
					width: 10
				},
				{ text: "ID Lote", value: "IDLots", width: 10 },
				{ text: "Tipo Carga", value: "TypeChargeName", width: 10 },
				{ text: "Cantidad Total", value: "PseQuantityTotal", width: 10 },
				{ text: "Placa", value: "TptEnrollment", width: 10 },
				{ text: "Destino", value: "TypeDestinyName", width: 50 },
				{ text: "PrdID", value: "PrdID", width: 50 },
				{ text: "N° Guia", value: "PseNumGuide", width: 100 },
				{ text: "Tipo Cultivo", value: "TypeCropName", width: 100 },
			]
		},

		objLot: {},
		ObjProducer: {},
		ObjTransport: {},
		objTypeLocation: {},
		/* objTypeCultive: {},
		
		ObjVariety: {}, */
		objTypeCrop: {},//samir
		TypeDestiny: 2,
		PrdID: 0,

		itemsDetails: [],
		itemsDetailsRemoved: [],
		selectedHeader: {},
		PsdQuantity: 0,
		PsdQuantityReal: 0,
		NameDrive: "",
		TypeVehicleName: "",

		VarietyID: null,
		programmingStorageSelected : [],
		referralGuideItems : [],

		dialogAssignVehicle: false,
		ObjTransportAssign: null,
		typeVehicleAssignName: "",
		driverAssignName: "",
		carrierAssignName: "",
		PseQuantityNegotiated: 0,
		PseQuantityJabas: 0,
		PseStowageQuantity: 0,
		PsePriceStowageQuantity: 0,
		PsePrice: 0,
		PseFalseFreight: 0,
		PseDescription: "",

		dialogAuditHistory: false,
		cutOffTimeStoragePalta: "",
		cutOffTimeStorageOther: "",

		TypeChargeAssign: null,
		selectedTypeChargeName: "",
		editingDetailLine: null,
		VrtName: ""
	}),

	computed: {
		varietyText() {
			if (this.objLot && (this.objLot.VrtDescription || this.objLot.VrtName)) {
				return this.objLot.VrtDescription || this.objLot.VrtName;
			}
			return this.VrtName || "";
		},
		chargeUnitLabel() {
			const name = (this.selectedTypeChargeName || (this.selectedHeader && this.selectedHeader.TypeChargeName) || "").toUpperCase();
			if (name.includes("BIN")) {
				return "Bines";
			}
			const val = this.TypeChargeAssign || (this.selectedHeader ? this.selectedHeader.TypeCharge : null);
			if (parseInt(val) === 2) {
				return "Bines";
			}
			return "Jabas";
		}
	},

	watch: {
		ObjTransportAssign() {
			if (this.ObjTransportAssign && this.ObjTransportAssign.VehPlate) {
				this.driverAssignName = this.ObjTransportAssign.Conductor || this.ObjTransportAssign.Driver || "";
				this.typeVehicleAssignName = this.ObjTransportAssign.DedDescription || this.ObjTransportAssign.TypeVehicleBrandName || "";
				this.carrierAssignName = this.ObjTransportAssign.SpcCompanyName || "";

				const vehId = this.ObjTransportAssign.VehID;
				if (vehId && !this.carrierAssignName) {
					_sVehicle.get({ VehID: vehId }, this.$fun.getUserID())
						.then(resp => {
							if (resp && resp.data && resp.data.SpcCompanyName) {
								this.carrierAssignName = resp.data.SpcCompanyName;
								if (this.ObjTransportAssign) {
									this.$set(this.ObjTransportAssign, 'SpcCompanyName', resp.data.SpcCompanyName);
								}
							}
						})
						.catch(() => {});
				}
			} else {
				this.driverAssignName = "";
				this.typeVehicleAssignName = "";
				this.carrierAssignName = "";
			}
		},
		ObjTransport() {
			if (this.ObjTransport && Object.keys(this.ObjTransport).length > 0) {
				this.NameDrive = this.ObjTransport.Conductor || this.ObjTransport.TptDriverName || null;
				this.TypeVehicleName = this.ObjTransport.DedDescription || this.ObjTransport.TypeVehicleName || null;
			} else {
				this.NameDrive = null;
				this.TypeVehicleName = null;
			}
		},
		ObjProducer(){
			if(this.ObjProducer == null){
				this.PrdID = 0
			}
			console.log(this.ObjProducer);
		},

		objLot(){
			console.log("dddddddddddddd",this.objLot);
			if(this.objLot == null){
				this.VarietyID = null
			}
		}
	},

	created() {
		_sParameter.search({ PrmName: "ShowVehicleApprovals" }, this.$fun.getUserID()).then(resp => {
			if (resp && resp.data) {
				this.ShowVehicleApprovals = resp.data.PrmValue;
			}
		});
		_sParameter.search({ PrmName: "CutOffTimeStoragePalta" }, this.$fun.getUserID()).then(resp => {
			if (resp && resp.data && resp.data.PrmValue) {
				this.cutOffTimeStoragePalta = resp.data.PrmValue;
			}
		});
		_sParameter.search({ PrmName: "CutOffTimeStorageOther" }, this.$fun.getUserID()).then(resp => {
			if (resp && resp.data && resp.data.PrmValue) {
				this.cutOffTimeStorageOther = resp.data.PrmValue;
			}
		});
	},

	methods: {
		closeDialogReferral() {
			this.dialogGuideSelected = false;
		},

		validateGroupGuide() {
			var errors = {
				error: 0,
				message: ''
			};

			if (this.programmingStorageSelected.length > 0) {
				let PrdIDOriginal = this.programmingStorageSelected[0].PrdID;
				let VehPlateOriginal = this.programmingStorageSelected[0].TptEnrollment;
				this.programmingStorageSelected.forEach(element => {
					if (element.PrdID != PrdIDOriginal) {
						errors.error = 1;
						errors.message = "Productores diferentes";
					}
					if (element.TptEnrollment != VehPlateOriginal) {
						errors.error = 1;
						errors.message = "Vehículos diferentes"
					}
				});
			}

			return errors;

		},

		openDialogGuide() {
			//validamos que no tengo una guia la programacion
			var hasguia = 0;
			var hasguiaPseID = 0;
			this.programmingStorageSelected.forEach(element => {
				if (element.PseStatusGuide > 0) {
					hasguia = hasguia + 1;
					hasguiaPseID = element.PseID;
				}
			})
			if (hasguia > 0) {
				this.$fun.alert("La programación ya tiene una guía generada - " + hasguiaPseID, "warning");
				return;
			}
			//
			let errors = this.validateGroupGuide();
			if (errors.error > 0) {
				this.$fun.alert(errors.message, "warning");
				return;
			}
			let objParam = {
				PrmName: "MOTIVOGUIAFRUTAACOPIO"
			};

			_sParameter
				.search(objParam, this.$fun.getUserID())
				.then((r) => {
					this.referralGuide.RegOtherMotive = r.data.PrmValue;

				});
			let detail = [];
			let counter = 0;
			this.referralGuideItems.forEach(element => {
				console.log('elementtt ', element);
				counter++;
				// this.TypeDestiny;
				console.log("this.TypeDestiny", this.TypeDestiny)
				console.log("element.TypeDestiny", element.TypeDestiny)
				let RgdDescriptionMsIQF = element.TypeCultiveName + ' PARA INDUSTRIA, ' + element.VrtName.toUpperCase() + ', ' + element.TypeCropName.toUpperCase() + ", " + element.PrdResponsibleName + ', FUNDO: ' + element.FagName + ', ' + element.PrdResponsibleDocumentNumber + ', ' + element.FltCodSenasa + ', ID: ' + element.FltID;
				let RgdDescriptionMsFRESH = element.TypeCultiveName + " FRESCO PARA EXPORTACIÓN, VARIEDAD: " + element.VrtName.toUpperCase() + ', FUNDO: ' + element.FagName + ', COD-SENASA: ' + element.FltCodSenasa + ', ' + element.PrdResponsibleDocumentNumber + ' ID: ' + element.FltID;

				detail.push({
					RgdLine: counter,
					DocEntry: element.PsdID,
					/* RgdDescription : element.TypeCultiveName + " " + element.TypeCropName + " Variedad: " 
						+ element.VrtName.toUpperCase()  */
					// + " Proveedor: " + element.PrdText
					// RgdDescription : element.TypeCultiveName + " PARA INDUSTRIA, "  + element.VrtName.toUpperCase() + "," + element.TypeCropName.toUpperCase() + "," + element.PrdResponsibleName + " " + "FUNDO: " + element.FagName + ", " + element.PrdResponsibleDocumentNumber + ", " + element.FltCodSenasa + ", ID: " + element.FltID,
					RgdDescription: this.TypeDestiny == 1 ? RgdDescriptionMsFRESH : RgdDescriptionMsIQF,
					RgdQuantity: element.PsdQuantityReal,
					RgdUnitMeasurement: "UND",
					TypeUnitMeasurement: 4,
					SecStatus: 1,
					UsrCreateID: this.$fun.getUserID(),
					TypeDetail: 1
				});
			});
			counter = 0;
			this.referralGuide.PrsDocumentNumberDriver = this.selectedHeader.NumDocDriver == null ? "" : this.selectedHeader.NumDocDriver.trim();
			this.referralGuide.NpdFullNameDriver = this.selectedHeader.TptDriverName == null ? "" : this.selectedHeader.TptDriverName.trim();
			this.referralGuide.RegAddressStartPoint = this.selectedHeader.FagAddress == null ? "" : this.selectedHeader.FagAddress.trim();
			this.referralGuide.NpdDocumentNumberDriver = this.selectedHeader.LicenseDriver;
			this.referralGuide.VehPlate = this.selectedHeader.TptEnrollment.trim();
			this.referralGuide.RegBrandTransport = this.selectedHeader.TypeBrandName;
			this.referralGuide.RegConstancyInscripcionTransport = this.selectedHeader.RegistrationConstancy;
			this.referralGuide.RegRucTransport = this.selectedHeader.VehRuc;
			this.referralGuide.RegBusinessNameTransport = this.selectedHeader.VehBusinessName;
			this.referralGuide.TypeAreGuide = 4;
			this.referralGuide.TypeUnitMeasurement = 3;

			this.referralGuide.referralGuideItems = detail;
			this.dialogGuideSelected = true;

		},

		getDetailByRowSelected() {
			this.referralGuideItems = [];
			this.programmingStorageSelected.forEach(element => {
				_sProgrammingStorageService
					.GetDetails(
						{ PseID: element.PseID },
						this.$fun.getUserID()
					)
					.then(r => {
						this.referralGuideItems.push(...r.data);
					});
			})

		},

		CleanAll() {

			this.objTypeLocation = {}
			/* this.objTypeCultive = {}*/
			this.objTypeCrop = {}
			this.ObjVariety = {}

			this.ObjProducer = {};
			this.itemsDetails = [];
			this.itemsDetailsRemoved = [];

			this.ObjTransport = {};
			this.NameDrive = null;
			this.TypeVehicleName = null;
			this.PsdQuantity = 0;
			this.PsdQuantityReal = 0;
			this.selectedHeader = {};
			this.PrdID = 0;
			this.disabled = false; // Habilitar edición al crear un nuevo registro
			this.TypeChargeAssign = null;
			this.selectedTypeChargeName = "";
		},
		validateCutOffTime(headerObj) {
			if (!headerObj || !headerObj.PseID || headerObj.PseID <= 0) {
				return { isValid: true };
			}

			let isPalta = false;
			if (this.itemsDetails && this.itemsDetails.length > 0) {
				isPalta = this.itemsDetails.some(item => parseInt(item.TypeCultive) === 3);
			} else if (headerObj.TypeCultive && parseInt(headerObj.TypeCultive) === 3) {
				isPalta = true;
			}

			let limitTimeStr = isPalta ? this.cutOffTimeStoragePalta : this.cutOffTimeStorageOther;

			// Si el parámetro está vacío, null, "0", "-1", "00:00" o "NONE", NO APLICA LÍMITE (Edición libre sin restricción)
			if (
				!limitTimeStr ||
				limitTimeStr.trim() === "" ||
				limitTimeStr.trim() === "0" ||
				limitTimeStr.trim() === "-1" ||
				limitTimeStr.trim() === "00:00" ||
				limitTimeStr.trim().toLowerCase() === "none"
			) {
				return { isValid: true };
			}

			limitTimeStr = limitTimeStr.trim();

			const now = new Date();
			
			// 1. Evaluar si la fecha de creación del registro es anterior a la fecha actual (ej. creado días atrás)
			let creationDateRaw = headerObj.SecCreate || headerObj.PseAproximateArrivaleDate;
			if (creationDateRaw) {
				const creationDate = new Date(creationDateRaw);
				const todayDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
				const creationDateOnly = new Date(creationDate.getFullYear(), creationDate.getMonth(), creationDate.getDate());

				// Si hoy es una fecha posterior a la fecha de creación del registro, el plazo de edición YA VENCIÓ
				if (todayDateOnly > creationDateOnly) {
					const cropName = isPalta ? "Palta" : "Otros Cultivos";
					const formattedCreationDate = this.$fun && typeof this.$fun.formatDateView === "function" 
						? this.$fun.formatDateView(creationDateRaw) 
						: creationDate.toLocaleDateString();
					return {
						isValid: false,
						message: `Se venció el plazo de edición para este registro creado el ${formattedCreationDate} (La hora límite fue ${limitTimeStr} hrs del día de creación).`,
						limitTime: limitTimeStr,
						isPalta
					};
				}
			}

			// 2. Si la fecha es HOY (mismo día de creación), evaluar si la hora actual supera la hora límite de hoy
			const currentHours = now.getHours();
			const currentMinutes = now.getMinutes();
			const currentMinutesTotal = currentHours * 60 + currentMinutes;

			const timeParts = limitTimeStr.split(":");
			const limitHours = parseInt(timeParts[0] || "0", 10);
			const limitMins = parseInt(timeParts[1] || "0", 10);
			const limitMinutesTotal = limitHours * 60 + limitMins;

			if (currentMinutesTotal > limitMinutesTotal) {
				const cropName = isPalta ? "Palta" : "Otros Cultivos";
				return {
					isValid: false,
					message: `Se superó la hora límite de edición (${limitTimeStr} hrs) para la programación de ${cropName}.`,
					limitTime: limitTimeStr,
					isPalta
				};
			}

			return { isValid: true };
		},

		EditEvent() {
			if (this.selectedHeader && this.selectedHeader.PseID > 0) {
				const cutOffResult = this.validateCutOffTime(this.selectedHeader);
				if (!cutOffResult.isValid) {
					this.disabled = true;
					this.$fun.alert(cutOffResult.message, "warning");
					return;
				}
			}
			if (this.selectedHeader && this.selectedHeader.PrdID) {
				this.PrdID = this.selectedHeader.PrdID;
			}
		},

		inputProducer(obj) {
			if (obj !== null) {
				if (obj.PrdID !== undefined) {
					this.PrdID = obj.PrdID
					// console.log("inputProducer", obj.PrdID);
				}
			}
		},

		inputLot(obj) {
			console.log("inputLot", obj);
			if (obj !== null && obj !== undefined) {
				this.VarietyID = obj.VrtID;
				this.VrtName = obj.VrtDescription || obj.VrtName || "";
				this.objTypeCrop = {
					DedValue: obj.TypeCrop,
					DedDescription: obj.TypeCropText || obj.TypeCropName
				};
			} else {
				this.VarietyID = null;
				this.VrtName = "";
			}
		},

		rowSelected(item) {
			console.log('rowselected', item);
			if (item.length > 0) {
				this.programmingStorageSelected = item;
				this.selectedHeader = item[0];
				this.getDetailByRowSelected();

				// Validar si vencio el horario limite para inhabilitar silenciosamente el boton de edicion en s-crud (sin alerta emergente)
				const cutOffResult = this.validateCutOffTime(this.selectedHeader);
				if (!cutOffResult.isValid) {
					this.disabled = true; // Inhabilita silenciosamente :edit="!disabled" en <s-crud> y oculta el boton de edicion
				} else {
					this.disabled = false;
				}

				this.PrdID = item[0].PrdID || 0;
				this.ObjProducer = {
					PrdID: item[0].PrdID,
					PrdName: item[0].PrdName
				};

				this.ObjTransport = {
					VehPlate: item[0].TptEnrollment,
					Conductor: item[0].TptDriverName,
					NumDocDriver: item[0].NumDocDriver,
					LicenseDriver: item[0].LicenseDriver,
					DedDescription: item[0].TypeVehicleName || item[0].TypeBrandName
				};

				this.NameDrive = item[0].TptDriverName || '';
				this.TypeVehicleName = item[0].TypeVehicleName || item[0].TypeBrandName || '';
				this.TypeDestiny = item[0].TypeDestiny;

				_sProgrammingStorageService
					.GetDetails(
						{ PseID: this.selectedHeader.PseID },
						this.$fun.getUserID()
					)
					.then(r => {
						this.itemsDetails = r.data;
						this.itemsDetails = this.itemsDetails.map(itemDetail => {
							return {
								...itemDetail,      // Copiar todas las propiedades actuales del objeto
								PrdID: item[0].PrdID // Añadir PrdID a cada objeto
							};
						});
						this.orderDetails();
					});
			}

			//this.NameDrive = null;
			//this.TypeVehicleName = null;

			console.log(this.programmingStorageSelected);
		},

			/*********************************** Cabcera Principal ************************** */

			/*********************************** FIN Cabcera Principal ************************** */

		isValidatedHeader(val) {
			var isValidated = true;

			if (this.selectedHeader.PseState == 2) {
				this.$fun.alert(
					"Registro ya fue recepcionado, no se pude actualizar datos",
					"warning"
				);
				isValidated = false;
				return;
			}

			if (this.selectedHeader && this.selectedHeader.PseID > 0) {
				const cutOffResult = this.validateCutOffTime(this.selectedHeader);
				if (!cutOffResult.isValid) {
					this.$fun.alert(cutOffResult.message, "warning");
					isValidated = false;
					return;
				}
			}

			// if (this.selectedHeader.PseState == 3) {
			// 	this.$fun.alert(
			// 		"Registro anulado, no se puede actualizar datos",
			// 		"warning"
			// 	);
			// 	isValidated = false;
			// 	return;
			// }

			if (val.PrdID == undefined) {
				this.$fun.alert("Debe un Especificar un Productor", "warning");
				isValidated = false;
				return;
			}

			// if (val.TptEnrollment == undefined) {
			// 	this.$fun.alert("Debe un Especificar un Transport", "warning");
			// 	isValidated = false;
			// 	return;
			// }

			// se esta validaadno , es para permitir que que 

			// if (val.PseAproximateArrivaleDate < this.$fun.getDate()) {
			// 	this.$fun.alert(
			// 		"Fecha de Recojo no puede ser menor a la fecha actual",
			// 		"warning"
			// 	);
			// 	isValidated = false;
			// 	return;
			// }

			if (this.itemsDetails.length == 0) {
				this.$fun.alert(
					"No existen detalles para esta Programación",
					"warning"
				);
				isValidated = false;
				return;
			}

			if(val.TypeProcessingPlant == 2){
				if(val.TypeBaler == undefined || val.TypeBaler == null){
					this.$fun.alert(
						"Debe especificar una Empacadora",
						"warning"
					);
					isValidated = false;
					return;
				}
			}

			return isValidated;
		},

		isValidatedDetails(item) {
			var isValidated = true;

			if (this.selectedHeader.PseState == 2) {
				this.$fun.alert(
					"No se puede agregar Item a Registro, Ya fue Recepcionado",
					"warning"
				);
				isValidated = false;
				return;
			}

			// if (this.selectedHeader.PseState == 3) {
			// 	this.$fun.alert(
			// 		"Registro anulado, no se pueden agregar item",
			// 		"warning"
			// 	);
			// 	isValidated = false;
			// 	return;
			// }

			if(this.objLot == null || this.objLot.FltID == undefined){
				this.$fun.alert("Seleccione un Lote", "warning");
				isValidated = false;
				return;
			}

			if (
				this.objTypeLocation.DedValue == undefined ||
				this.objTypeLocation.DedValue == null
			) {
				this.$fun.alert("Debe un Especificar una Localidad", "warning");
				isValidated = false;
				return;
			}

				if (
				this.objTypeCrop == undefined ||
				this.objTypeCrop.DedValue == undefined ||
				this.objTypeCrop == ""
			) {
				this.$fun.alert(
					"Debe un Especificar un Tipo de Cultivo",
					"warning"
				);
				isValidated = false;
				return;
			}  

			/* if (
				this.objTypeCultive.DedValue == undefined ||
				this.objTypeCultive == null
			) {
				this.$fun.alert("Debe un Especificar un Cultivo", "warning");
				isValidated = false;
				return;
			} */

			/* if (this.ObjVariety == null || this.ObjVariety.VrtID == undefined) {
				this.$fun.alert("Debe un Especificar una Variedad", "warning");
				isValidated = false;
				return;
			} */

			if (this.VarietyID == null || this.VarietyID == undefined) {
				this.$fun.alert("Debe un Especificar una Variedad", "warning");
				isValidated = false;
				return;
			}

			if (this.PsdQuantity == undefined) {
				this.$fun.alert("Debe un Especificar una Cantidad", "warning");
				isValidated = false;
				return;
			}

			if (this.PsdQuantity == 0) {
				this.$fun.alert("La Cantidad debe ser mayor a 0", "warning");
				isValidated = false;
				return;
			}

			return isValidated;
		},

		isValidatedRemoveItem() {
			var isvalid = true;
			if (this.selectedHeader.PseState == 2) {
				this.$fun.alert(
					"No se puede quitar Item a Registro, Ya fue Recepcionado",
					"warning"
				);
				isvalid = false;
				return;
			}

			// if (this.selectedHeader.PseState == 3) {
			// 	this.$fun.alert(
			// 		"Registro anulado, no se pueden quitar item",
			// 		"warning"
			// 	);
			// 	isvalid = false;
			// 	return;
			// }

			return isvalid;
		},

		isValidatedRemove() {
			var isvalid = true;

			if (
				this.selectedHeader.PseID == 0 ||
				this.selectedHeader.PseID == undefined
			) {
				this.$fun.alert("Seleccione registro", "warning");
				isvalid = false;
				return;
			}

			if (this.selectedHeader.PseState == 2) {
				this.$fun.alert(
					"No se puede eliminar, ya esta recepcionado",
					"warning"
				);
				isvalid = false;
				return;
			}

			// if (this.selectedHeader.PseState == 3) {
			// 	this.$fun.alert(
			// 		"No se puede eliminar, Registro anulado",
			// 		"warning"
			// 	);
			// 	isvalid = false;
			// 	return;
			// }
			return isvalid;
		},

		isValidatedDuplicate() {
			var isvalid = true;

			if (
				this.selectedHeader.PseID == 0 ||
				this.selectedHeader.PseID == undefined
			) {
				this.$fun.alert("Seleccione registro", "warning");
				isvalid = false;
				return;
			}

			// if (this.selectedHeader.PseState == 3) {
			// 	this.$fun.alert(
			// 		"No se puede duplicar, registro esta anulado",
			// 		"warning"
			// 	);
			// 	isvalid = false;
			// 	return;
			// }

			if (this.selectedHeader.PseState == 2) {
				this.$fun.alert(
					"No se puede duplicar, registro ya fue recepcionado",
					"warning"
				);
				isvalid = false;
				return;
			}

			return isvalid;
		},

		/*********************************** Detalles ************************** */

		orderDetails() {
			let i = 0;
			this.itemsDetails.map(e => {
				i++;
				e.Line = i;
			});
		},

		editDetailItem(item) {
			this.editingDetailLine = item.Line;
			if (item.PrdID) {
				this.PrdID = item.PrdID;
			}

			const cropVal = item.TypeCrop || item.TypeCultive;
			const cropName = item.TypeCropName || item.TypeCultiveName;

			this.objLot = {
				FltID: item.FltID,
				FltName: item.FltName || item.VrtName,
				FltNameOne: item.FltName || item.VrtName,
				TypeCrop: cropVal,
				TypeCultive: cropVal,
				TypeCropText: cropName,
				VrtID: item.VrtID,
				VrtDescription: item.VrtName,
				VrtName: item.VrtName
			};

			this.objTypeLocation = {
				DedValue: item.TypeLocation,
				DedDescription: item.TypeLocationName
			};

			this.objTypeCrop = {
				DedValue: cropVal,
				DedDescription: cropName
			};

			this.VarietyID = item.VrtID;
			this.VrtName = item.VrtName || "";
			this.PsdQuantity = item.PsdQuantity || 0;
			this.PsdQuantityReal = item.PsdQuantityReal || 0;
		},

		cancelEditDetail() {
			this.editingDetailLine = null;
			this.objTypeLocation = {};
			this.objTypeCrop = {};
			this.ObjVariety = {};
			this.objLot = null;
			this.PsdQuantity = 0;
			this.PsdQuantityReal = 0;
			this.VarietyID = null;
			this.VrtName = "";
		},

		newItem() {
			if (!this.isValidatedDetails()) {
				return;
			}

			const lotFltID = this.objLot ? (this.objLot.FltID || 0) : 0;
			const lotFltName = this.objLot ? (this.objLot.FltNameOne || this.objLot.FltName || this.objLot.VrtDescription || "") : "";
			
			const locationVal = this.objTypeLocation ? (this.objTypeLocation.DedValue !== undefined ? this.objTypeLocation.DedValue : this.objTypeLocation) : 0;
			const locationName = this.objTypeLocation ? (this.objTypeLocation.DedDescription || "") : "";

			const cropVal = this.objTypeCrop ? (this.objTypeCrop.DedValue !== undefined ? this.objTypeCrop.DedValue : (this.objLot ? this.objLot.TypeCrop : 0)) : 0;
			const cropName = this.objTypeCrop ? (this.objTypeCrop.DedDescription || (this.objLot ? (this.objLot.TypeCropText || this.objLot.TypeCropName) : "")) : "";

			const vrtID = this.VarietyID || (this.objLot ? this.objLot.VrtID : 0);
			const vrtName = (this.objLot && (this.objLot.VrtDescription || this.objLot.VrtName)) ? (this.objLot.VrtDescription || this.objLot.VrtName) : "";

			// Si estamos actualizando una línea de detalle existente
			if (this.editingDetailLine) {
				const index = this.itemsDetails.findIndex(x => x.Line === this.editingDetailLine);
				if (index !== -1) {
					const existing = this.itemsDetails[index];
					this.itemsDetails.splice(index, 1, {
						...existing,
						FltID: lotFltID || existing.FltID,
						FltName: lotFltName || existing.FltName,
						TypeLocation: locationVal || existing.TypeLocation,
						TypeLocationName: locationName || existing.TypeLocationName,
						TypeCrop: cropVal || existing.TypeCrop,
						TypeCropName: cropName || existing.TypeCropName,
						VrtID: vrtID || existing.VrtID,
						VrtName: vrtName || existing.VrtName,
						PsdQuantity: this.PsdQuantity,
						PsdQuantityReal: this.PsdQuantityReal
					});
					this.$fun.alert("Item de detalle actualizado correctamente", "success");
					this.cancelEditDetail();
					return;
				}
			}

			// Si es un item nuevo
			let item = {
				Line: this.itemsDetails.length + 1,
				FltID: lotFltID,
				FltName: lotFltName,
				PrdID: this.PrdID,
				TypeLocation: locationVal,
				TypeLocationName: locationName,
				TypeCrop: cropVal,
				TypeCropName: cropName,
				VrtID: vrtID,
				VrtName: vrtName,
				PsdQuantity: this.PsdQuantity,
				PsdQuantityReal: this.PsdQuantityReal,
				SecStatus: 1,
				UsrCreateID: this.$fun.getUserID()
			};

			var exist = false;
			this.itemsDetails.forEach(element => {
				if (vrtID == element.VrtID) {
					exist = true;
					this.$fun.alert(
						"No se puede agregar misma variedad",
						"warning"
					);
				}
			});

			if (exist == false) {
				this.itemsDetails.push(item);
				this.cancelEditDetail();
			}
		},

		removeItem(item) {
			if (this.editingDetailLine === item.Line) {
				this.cancelEditDetail();
			}
			if (this.itemsDetails.length > 0) {
				if (item.PsdID > 0) {
					this.itemsDetailsRemoved.push(
						this.itemsDetails.filter(x => x.Line == item.Line)[0]
					);
					this.itemsDetailsRemoved.forEach(element => {
						element.SecStatus = 0;
					});
				}

				this.itemsDetails = this.itemsDetails.filter(
					x => x.Line != item.Line
				);
				this.orderDetails();
			}
		},
		/**************************************** ************************** */

		save(val) {
			if(this.PrdID == 0 || this.PrdID == undefined){
				this.$fun.alert("Error, al parecer no se ha cargado el productor, vuelva a seleccionar el registro", "warning");
				return
			}
			else {
				const hasDifferentPrdID = this.itemsDetails.some(itemDetail => itemDetail.PrdID !== this.PrdID);

				if (hasDifferentPrdID) {
					this.$fun.alert("Uno de los detalles no pertenece al productor", "warning")
					return;
				}
			}

			val.SecStatus = 1;
			val.UsrCreateID = this.$fun.getUserID();
			val.PrdID = (this.ObjProducer && this.ObjProducer.PrdID) ? this.ObjProducer.PrdID : this.PrdID;
			val.TypeDestiny = this.TypeDestiny;

			val.TptEnrollment = (this.ObjTransport && this.ObjTransport.VehPlate) ? this.ObjTransport.VehPlate : (this.selectedHeader ? this.selectedHeader.TptEnrollment : null);
			val.TptDriverName = (this.ObjTransport && this.ObjTransport.Conductor) ? this.ObjTransport.Conductor : (this.selectedHeader ? this.selectedHeader.TptDriverName : null);
			val.NumDocDriver = (this.ObjTransport && this.ObjTransport.NumDocDriver) ? this.ObjTransport.NumDocDriver : (this.selectedHeader ? this.selectedHeader.NumDocDriver : null);
			val.LicenseDriver = (this.ObjTransport && this.ObjTransport.LicenseDriver) ? this.ObjTransport.LicenseDriver : (this.selectedHeader ? this.selectedHeader.LicenseDriver : null);

			// if (!val.TptDriverName) {
			// 	this.$fun.alert("Error, al parecer no se ha cargado el conductor, vuelva a seleccionar el vehículo", "warning")
			// 	return;
			// }
			
			if (!this.selectedHeader || !this.selectedHeader.PseState) {
				val.PseState = 3;
			} else {
				val.PseState = this.selectedHeader.PseState;
			}
			// if(val.TptDriverName == undefined){
			// 	this.$fun.alert("Error, al parecer no se ha cargado el conductor, vuelva a seleccionar el registro", "warning")
			// 	return;
			// }

			if (!this.isValidatedHeader(val)) {
				return;
			}

			val.TasProgrammingStorageDetail = [
				...this.itemsDetails,
				...this.itemsDetailsRemoved
			];
				
			val.save();

			console.log("Guardar", val);
		},

		remove() {
			if (!this.isValidatedRemove()) {
				return;
			}

			this.$fun
				.alert("Seguro de Eliminar registro?", "question")
				.then(val => {
					if (val.value) {
						_sProgrammingStorageService
							.delete(
								{
									PseID: this.selectedHeader.PseID,
									UsrCreateID: this.$fun.getUserID()
								},
								this.$fun.getUserID()
							)
							.then(r => {
								if(r.status == 200){
									this.$fun.alert(
										"Eliminado Correctamente",
										"success"
									);
									this.selectedHeader.PseID = 0
									this.$refs.gridProgrammingStorage.refresh();
								}
								
							});
					}
				});
		},

		duplicate() {
			if (!this.isValidatedDuplicate()) {
				return;
			}

			this.$fun
				.alert(
					"Esta seguro de Duplicar el registro ? " +
						this.selectedHeader.PseID,
					"question"
				)
				.then(r => {
					this.itemsDetails = r.data;
					this.itemsDetails = this.itemsDetails.map(itemDetail => {
						return {
							...itemDetail,      // Copiar todas las propiedades actuales del objeto
							PrdID: item[0].PrdID // Añadir PrdID a cada objeto
						};
					});
					this.orderDetails();
				});
		},

		openDialogAssignVehicle() {
			if (!this.programmingStorageSelected || this.programmingStorageSelected.length !== 1) {
				this.$fun.alert("Debe seleccionar solo un registro para asignar vehículo", "warning");
				return;
			}
			if (!this.selectedHeader || !this.selectedHeader.PseID) {
				this.$fun.alert("Seleccione un registro", "warning");
				return;
			}

			if (this.selectedHeader.TptEnrollment) {
				let plate = this.selectedHeader.TptEnrollment;
				this.ObjTransportAssign = {
					VehPlate: plate,
					TptEnrollment: plate,
					Conductor: this.selectedHeader.TptDriverName,
					Driver: this.selectedHeader.TptDriverName,
					NumDocDriver: this.selectedHeader.NumDocDriver,
					LicenseDriver: this.selectedHeader.LicenseDriver,
					CfvCapacity: this.selectedHeader.CfvCapacity || 0,
					CfvCapacityMin: this.selectedHeader.CfvCapacityMin || 0,
					SpcCompanyName: ""
				};
				this.driverAssignName = this.selectedHeader.TptDriverName || "";
				this.typeVehicleAssignName = "";
				this.carrierAssignName = "";

				// Cargar datos completos del vehículo para recuperar CfvCapacity, CfvCapacityMin y SpcCompanyName al editar
				_sHarvest.listTransport(0, plate, this.$fun.getUserID())
					.then(resp => {
						if (resp && resp.status == 200 && resp.data && resp.data.length > 0) {
							let found = resp.data.find(x => (x.VehPlate == plate || x.TptEnrollment == plate)) || resp.data[0];
							if (found && this.ObjTransportAssign && (this.ObjTransportAssign.VehPlate == plate || this.ObjTransportAssign.TptEnrollment == plate)) {
								this.ObjTransportAssign = {
									...this.ObjTransportAssign,
									...found,
									CfvCapacity: found.CfvCapacity || 0,
									CfvCapacityMin: found.CfvCapacityMin || 0,
									SpcCompanyName: found.SpcCompanyName || this.carrierAssignName || ""
								};
								if (found.VehID) {
									_sVehicle.get({ VehID: found.VehID }, this.$fun.getUserID()).then(vRes => {
										if (vRes && vRes.data && vRes.data.SpcCompanyName) {
											this.carrierAssignName = vRes.data.SpcCompanyName;
											this.$set(this.ObjTransportAssign, 'SpcCompanyName', vRes.data.SpcCompanyName);
										}
									}).catch(() => {});
								}
							}
						}
					})
					.catch(() => {});
			} else {
				this.ObjTransportAssign = null;
				this.typeVehicleAssignName = "";
				this.driverAssignName = "";
				this.carrierAssignName = "";
			}

			this.PseQuantityNegotiated = this.selectedHeader.PseQuantityNegotiated || 0;
			this.PseQuantityJabas = this.selectedHeader.PseQuantityJabas || this.selectedHeader.PseQuantityRealJabas || 0;
			this.PseStowageQuantity = this.selectedHeader.PseStowageQuantity || 0;
			this.PsePriceStowageQuantity = this.selectedHeader.PsePriceStowageQuantity || 0;
			this.PsePrice = this.selectedHeader.PsePrice || 0;
			this.PseFalseFreight = this.selectedHeader.PseFalseFreight || 0;
			this.PseDescription = this.selectedHeader.PseDescription || "";

			this.TypeChargeAssign = this.selectedHeader ? (this.selectedHeader.TypeCharge || null) : null;
			this.selectedTypeChargeName = this.selectedHeader ? (this.selectedHeader.TypeChargeName || "") : "";

			this.dialogAssignVehicle = true;
		},

		changeTypeChargeAssign(item) {
			if (item && typeof item === 'object') {
				this.selectedTypeChargeName = item.DedDescription || item.DedName || "";
				this.TypeChargeAssign = item.DedValue || item.DefID || item;
			} else {
				this.TypeChargeAssign = item;
				if (parseInt(item) === 2) {
					this.selectedTypeChargeName = "BINES";
				} else if (parseInt(item) === 1) {
					this.selectedTypeChargeName = "JABAS";
				}
			}
		},

		clearAssignVehicle() {
			this.ObjTransportAssign = null;
			this.typeVehicleAssignName = "";
			this.driverAssignName = "";
			this.carrierAssignName = "";
		},

		saveAssignVehicle() {
			if (!this.selectedHeader || !this.selectedHeader.PseID) {
				this.$fun.alert("Seleccione un registro", "warning");
				return;
			}

			this.$fun.alert("¿Seguro de guardar la asignación?", "question").then(r => {
				if (r.value) {
					let header = { ...this.selectedHeader };
					if (this.ObjTransportAssign && this.ObjTransportAssign.VehPlate) {
						header.TptEnrollment = this.ObjTransportAssign.VehPlate;
						header.TptDriverName = this.ObjTransportAssign.Conductor || this.ObjTransportAssign.Driver || "";
						header.NumDocDriver = this.ObjTransportAssign.NumDocDriver || "";
						header.LicenseDriver = this.ObjTransportAssign.LicenseDriver || "";
						header.PseState = 1;
					} else {
						header.TptEnrollment = "";
						header.TptDriverName = "";
						header.NumDocDriver = "";
						header.LicenseDriver = "";
						header.PseState = 3;
					}

					header.TypeCharge = this.TypeChargeAssign || header.TypeCharge || 0;
					header.PseQuantityNegotiated = this.PseQuantityNegotiated || 0;
					header.PseQuantityJabas = this.PseQuantityJabas || 0;
					header.PseStowageQuantity = this.PseStowageQuantity || 0;
					header.PsePriceStowageQuantity = parseFloat(this.PsePriceStowageQuantity) || 0;
					header.PsePrice = parseFloat(this.PsePrice) || 0;
					header.PseFalseFreight = parseFloat(this.PseFalseFreight) || 0;
					header.PseDescription = this.PseDescription || "";

					header.SecStatus = 1;
					header.UsrCreateID = this.$fun.getUserID();

					_sProgrammingStorageService
						.GetDetails(
							{ PseID: header.PseID },
							this.$fun.getUserID()
						)
						.then(r => {
							header.TasProgrammingStorageDetail = r.data || [];
							_sProgrammingStorageService
								.save(header, this.$fun.getUserID())
								.then(res => {
									if (res && res.status == 200) {
										this.$fun.alert(
											"Asignación de vehículo guardada correctamente",
											"success"
										);
										this.dialogAssignVehicle = false;
										if (this.$refs.gridProgrammingStorage) {
											this.$refs.gridProgrammingStorage.refresh();
										}
									}
								});
						});
				}
			});
		},

		async changeTraspot(item) {
			if (!item) {
				this.ObjTransport = {};
				this.NameDrive = '';
				this.TypeVehicleName = '';
				return;
			}
			if (this.ShowVehicleApprovals == 1) {
				const vehId = item.VehID;
				if (!vehId) return;
				try {
					const response = await _sVehicle.get({ VehID: vehId }, this.$fun.getUserID());
					if (response && response.data) {
						const vehicle = response.data;
						// console.log(JSON.parse(JSON.stringify({ vehicle })));
						if (vehicle.VehStatus !== 2) {
							this.TypeVehicleName = '';
							this.NameDrive = '';
							this.ObjTransport = {};
							this.$fun.alert(`El vehículo no se encuentra aprobado para proceder. Estado actual: ${vehicle.VehStatusText || 'Desconocido'}`, "warning");
							return;
						}
					}
				} catch (error) {
					console.error("Error fetching vehicle details:", error);
				}
			}
			this.ObjTransport = item;
			// console.log(JSON.parse(JSON.stringify({ item })));
		},

		openDialogAuditHistory() {
			if (!this.selectedHeader || !this.selectedHeader.PseID) {
				this.$fun.alert("Seleccione un registro", "warning");
				return;
			}
			this.dialogAuditHistory = true;
		},

		//**************************** *************** Grilla de Detalle ********************************************************
	}
};
</script>

<style scoped>
.opacity-80 {
	opacity: 0.85;
}
.bg-light {
	background-color: #f8fafc;
}
.border-subtle {
	border: 1px solid #e2e8f0;
}
.border-subtle-bottom {
	border-bottom: 1px solid #e2e8f0;
}
.border-dashed {
	border: 2px dashed #cbd5e1;
}
.lh-1 {
	line-height: 1.2;
}
.pulse-animation {
	animation: pulse 2s infinite;
}
@keyframes pulse {
	0% {
		transform: scale(0.98);
		opacity: 0.7;
	}
	50% {
		transform: scale(1.05);
		opacity: 1;
	}
	100% {
		transform: scale(0.98);
		opacity: 0.7;
	}
}
</style>
